module.exports = __webpack_public_path__ + "assets/img/1251587028463_.pic_hd.fffe8c7c.jpg";